<template>
  <bs-layout>
    <template v-slot:layout-left>
      <bs-box-panel title="农场介绍">
        <BsFarmModule01 ref="farmInfoRef" @closeAll="closeAllDisalog" />
      </bs-box-panel>
      <bs-box-panel title="生产资源">
        <production-resources></production-resources>
      </bs-box-panel>
      <bs-box-panel title="种养品类">
        <BsFarmModule03 />
      </bs-box-panel>
    </template>
    <template v-slot:layout-right>
      <video-surveillance></video-surveillance>
      <environmental-monitoring></environmental-monitoring>
      <bs-box-panel title="农产品溯源">
        <agri-trace ref="traceRef" @closeAll="closeAllDisalog"></agri-trace>
      </bs-box-panel>
    </template>
    <template v-slot:layout-bottom>
      <agricultural-work></agricultural-work>
      <bs-box-panel title="价格走势">
        <price-trend></price-trend>
      </bs-box-panel>
      <bs-box-panel title="绿色认证">
        <BsFarmModule06 ref="lvseRef" @closeAll="closeAllDisalog" />
      </bs-box-panel>
    </template>
    <template>
      <farm-detail ref="mapDetail" @closeAll="closeAllDisalog"></farm-detail>
    </template>
  </bs-layout>
</template>

<script>
import BsLayout from "@/views/bs/BsLayout";
import BsBoxPanel from "@/components/bs/BsBoxPanel";
import BsFarmModule01 from "@/views/bs/Farm/components/BsFarmModule01";
import ProductionResources from "@/views/bs/Farm/components/ProductionResources";
import PriceTrend from "@/views/bs/Farm/components/PriceTrend";
import AgriTrace from "@/views/bs/Farm/components/AgriTrace";
import BsFarmModule03 from "@/views/bs/Farm/components/BsFarmModule03";
import BsFarmModule06 from "@/views/bs/Farm/components/BsFarmModule06";
import EnvironmentalMonitoring from "@/views/bs/Farm/components/EnvironmentalMonitoring";
import VideoSurveillance from "@/views/bs/Farm/components/VideoSurveillance";
import AgriculturalWork from "@/views/bs/Farm/components/AgriculturalWork";
import FarmDetail from "./components/Detail";

export default {
  name: "BSFarm",
  components: {
    BsLayout,
    BsBoxPanel,
    FarmDetail,
    BsFarmModule01,
    ProductionResources,
    VideoSurveillance,
    PriceTrend,
    AgriTrace,
    BsFarmModule03,
    EnvironmentalMonitoring,
    AgriculturalWork,
    BsFarmModule06,
  },
  data() {
    return {
      totalCount: 0,
      startVal: 0,
      endVal: 0,
      duration: 3000,
    };
  },
  mounted() {},
  methods: {
    closeAllDisalog() {
      window.layer.closeAll();
      this.$refs.farmInfoRef && (this.$refs.farmInfoRef.showDialog = false);
      this.$refs.mapDetail &&
        (this.$refs.mapDetail.visibilityLandDialog = false);
      this.$refs.traceRef && (this.$refs.traceRef.visibility = false);
      this.$refs.lvseRef && (this.$refs.lvseRef.showDialog = false);
    },
  },
};
</script>

<style scoped lang="scss">
@include bs(box-panel) {
  margin-top: 15px;
  height: calc(33.33vh - 46.67px);
  @include pseudo(first-child) {
    margin-top: 0;
  }
}
::v-deep {
  .sn-bs-layout__section--bottom {
    padding: 0 12px;
    .sn-bs-box-panel {
      margin-top: 0;
      height: calc(33.33vh - 51.667px);
      @include pseudo("nth-child(2)") {
        margin: 0 12px;
      }
    }
  }
}
</style>
